module.exports = __webpack_public_path__ + "13f5e5025260f19ee3eef9c3810649b6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-14.png
// module id = 2934
// module chunks = 0